'use strict';
/* global jQuery */
/* global require */
const util = require('util');

angular
  .module('apps')
  .component('apps', {
    template: require('./apps.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'uiGmapGoogleMapApi', 'CenterInfo',
      function OrdersSubscriptionController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        const APIURL = envService.read('apiUrl');

        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'apps';

        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        this.isLevel2Auth = AuthService.isLevel2Authenticated();
        this.latestMaintenance = { ID: 0, ACTIVATED: 'N', TB_ADMIN_NAME: 'System', REGDATE_UTC: new Date() };
        this.maintenances = {};
        this.maintenancesCurrentPage = 1;
        this.appReleases = {};
        this.appReleasesCurrentPage = 1;
        this.newRelease = undefined;

        this.loadMaintenances = (page) => {
          $resource(`${APIURL}/admin/services/maintenances`)
            .get({ limit: 5, offset: 5 * (page - 1) })
            .$promise
            .then((data) => {
              if (this.maintenancesCurrentPage === 1) {
                if (data.data && data.data.length > 0) {
                  this.latestMaintenance = data.data[0];
                }
              }
              this.maintenances = data;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.loadMaintenances(this.maintenancesCurrentPage);

        this.showMaintenanceHistory = () => {
          if (!this.isLevel2Auth) {
            return;
          }
          jQuery('#modal-maintenances').modal('show');
        };

        this.showMaintenanceEditModal = () => {
          if (!this.isLevel2Auth) {
            return;
          }
          this.newMaintenance = {
            ACTIVATED: this.latestMaintenance.ACTIVATED === 'Y' ? 'N' : 'Y',
            MESSAGE_KO: '',
            MESSAGE_JA: '',
            MESSAGE_TH: '',
            MESSAGE_EN: '',
          };
          jQuery('#modal-maintenance-edit').modal('show');
        };

        this.createMaintenance = () => {
          const strUrl = `${APIURL}/admin/services/maintenances`;
          if (this.newMaintenance.ACTIVATED === 'Y') {
            if (!this.newMaintenance.MESSAGE_KO) {
              alert($translate.instant('메세지를 입력해주세요.'));
              return;
            }
            if (!this.newMaintenance.MESSAGE_JA) {
              alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('일어 번역')));
              return;
            }
            if (!this.newMaintenance.MESSAGE_TH) {
              alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('태국어 번역')));
              return;
            }
            if (!this.newMaintenance.MESSAGE_EN) {
              alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('영문 번역')));
              return;
            }
          }

          if (this.newMaintenance.ACTIVATED === 'Y' && !confirm('유지보수 모드를 활성화 하시겠습니까?\n저장 즉시 서버에 반영되며, 사용자는 앱 사용이 제한됩니다.')) {
            return;
          }
          if (this.newMaintenance.ACTIVATED !== 'Y' && !confirm('유지보수 모드를 비활성화 하시겠습니까?\n저장 즉시 서버에 반영되며, 사용자는 앱 사용이 가능해 집니다.')) {
            this.newMaintenance.MESSAGE_KO = '';
            this.newMaintenance.MESSAGE_JA = '';
            this.newMaintenance.MESSAGE_TH = '';
            this.newMaintenance.MESSAGE_EN = '';
            return;
          }

          $resource(strUrl)
            .save(this.newMaintenance)
            .$promise
            .then(() => {
              this.maintenancesCurrentPage = 1;
              this.loadMaintenances(this.maintenancesCurrentPage);
              jQuery('#modal-maintenance-edit').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                console.log(err.data);
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.loadAppReleases = (page) => {
          this.appReleasesCurrentPage = page;
          $resource(`${APIURL}/admin/services/apps/releases`)
            .get({ limit: 5, offset: 5 * (page - 1) })
            .$promise
            .then((data) => {
              console.log(`appReleases=${JSON.stringify(data)}`);
              this.appReleases = data;
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.loadAppReleases(this.appReleasesCurrentPage);

        this.showAppReleaseModal = (release) => {
          if (!this.isLevel2Auth) {
            return;
          }

          if (release) {
            this.newRelease = JSON.parse(JSON.stringify(release));
          } else {
            this.newRelease = { OS_TYPE: '', MODE: 'NONE', MESSAGE: '', MESSAGE_EN: '', TRANSFER_YN: 'N', TRANSFER_LINK: '' };
          }
          jQuery('#modal-new-release').modal('show');
        };

        this.createAppRelease = () => {
          const strUrl = `${APIURL}/admin/services/apps/releases`;
          if (!this.newRelease.OS_TYPE) {
            alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('플랫폼')));
            return;
          }
          if (!this.newRelease.VERSION) {
            alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('버전')));
            return;
          }
          const verRegx = /^\d{1,2}\.\d{1,2}\.\d{1,2}$/;
          if (!verRegx.test(this.newRelease.VERSION)) {
            alert(util.format($translate.instant('%s이(가) 유효하지 않습니다.'), $translate.instant('버전')));
            return;
          }
          if (this.newRelease.MODE !== 'NONE') {
            if (!this.newRelease.MESSAGE) {
              alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('메시지')));
              return;
            }
            if (!this.newRelease.MESSAGE_EN) {
              alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('영문 번역')));
              return;
            }
          }
          if (this.newRelease.TRANSFER_YN === 'Y') {
            if (!this.newRelease.TRANSFER_LINK) {
              alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('업데이트 링크 e.g) market://details?id=xx.xx.xx')));
              return;
            }
          }

          if (this.newRelease.MODE !== 'NONE' && !confirm('앱 릴리즈를 저장하시겠습니까?\n저장 즉시 서버에 반영되며, 사용자 앱에 팝업이 출력됩니다.')) {
            return;
          }

          if (this.newRelease.ID) {
            const Release = $resource(`${strUrl}/:id`, { id: '@id' }, {
              update: { method: 'PUT' },
            });
            Release.update({ id: this.newRelease.ID }, this.newRelease)
              .$promise
              .then(() => {
                this.appReleasesCurrentPage = 1;
                this.loadAppReleases(this.appReleasesCurrentPage);
                jQuery('#modal-new-release').modal('hide');
              })
              .catch((err) => {
                if (err.data && err.data.msg) {
                  alert(err.data.msg);
                } else {
                  alert($translate.instant('알수 없는 에러 입니다.'));
                }
              });
          } else {
            $resource(strUrl)
              .save(this.newRelease)
              .$promise
              .then(() => {
                this.appReleasesCurrentPage = 1;
                this.loadAppReleases(this.appReleasesCurrentPage);
                jQuery('#modal-new-release').modal('hide');
              })
              .catch((err) => {
                if (err.data && err.data.msg) {
                  alert(err.data.msg);
                } else {
                  alert($translate.instant('알수 없는 에러 입니다.'));
                }
              });
          }
        };

        this.deleteAppRelease = (release) => {
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/services/apps/releases/:release_id`, { release_id: release.ID }).delete(
            () => {
              this.appReleases.data.splice(this.appReleases.data.indexOf(release), 1);
              jQuery('#modal-new-release').modal('hide');
            }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/service/apps/apps.component.js